import { keys, forEach } from 'lodash';
import { isEmptyVal, noopPromise } from '@/utils';
import { billingConfig$Cache } from '@/common/service/common';
import { dateTimeFormat } from '@/utils/dateformat';
import { translation } from '@/plugins/i18n';
import { ACCOUNT_SALE_CHANNEL } from '@/common/constants';

const state = {
  basicConfig: {
    hasPendingCoupon: false,
    pendingCouponEffectiveDate: null,
    allowMonthly2Annual: false,
    hasPendingPlans: false,
    couponExpireDate: null,
    canSelectBiz: false,
    canSelectBizPlus: false,
    isBulkLicenseAccount: false,
    isSMBCustomer: false,
    freeStorage: false,
    bizCanDowngrade: true,
    isCustomPricing4MajorPlan: false,
    canSelectProPlus: true,
    ZCMDefaultStorage: null,
    multiSubscriptionEnabled: false,
    downSellData: {
      disableDownSell: false,
      mrs: undefined,
      currentTerm: undefined,
      renewalTerm: undefined,
      subscriptionEndDate: undefined,
      currentTermPeriodType: undefined,
      renewalTermPeriodType: undefined,
    }
  },
  successConfig: {
    eligibleProductTypeJson: []
  },
  pendingFreeTrialCoupon: '',
  activeProToBizBanner: false,
};

const getters = {
  basicConfig: (state) => state.basicConfig,
  isOnlineSalesChannel: (state) => state.basicConfig.salesChannel === ACCOUNT_SALE_CHANNEL.ONLINE,
  disableMonthly2AnnualTip(state, getters) {
    const { allowMonthly2Annual, hasPendingPlans, couponExpireDate } = getters.basicConfig || {};

    if (allowMonthly2Annual) {
      if (hasPendingPlans) {
        return translation('billing.error.has_pending_plans_change_tips');
      } else if (!isEmptyVal(couponExpireDate) && window.campaignFlags?.disableMonthly2AnnualTip4TimeBaseCoupon) {
        const date = dateTimeFormat(couponExpireDate);
        return translation('billing.error.has_time_based_discount_change_tips', [date]);
      }
    }

    return '';
  },
  successConfig: (state) => state.successConfig,
  activeProToBizBanner: (state) => state.activeProToBizBanner,
};

const mutations = {
  setBasicConfig(state, data = {}) {
    forEach(keys(data), (key) => {
      state.basicConfig[key] = data[key];
    });
  },
  setSuccessConfig(state, data = {}) {
    forEach(keys(data), (key) => {
      state.successConfig[key] = data[key];
    });
  },
  setActiveProToBizBanner(state, isActived) {
    state.activeProToBizBanner = isActived;
  },
};

const actions = {
  async getBasicConfig({ commit }) {
    const isLoggedIn = window.$context?.is?.loggedIn;
    const fetchConfigApi = isLoggedIn ? billingConfig$Cache : noopPromise;
    const { result } = (await fetchConfigApi() || {});
    // This is to block downsell in single msq account's online self service flow.
    if (
      (window.newBillingConfig.allowMSQAccountOnlineSelfService && result.salesChannel !== 'Online') &&
      result.downSellData
    ) {
      result.downSellData.disableDownSell = true
    }
    commit('setBasicConfig', result);
  }
};

export default {
  state,
  getters,
  mutations,
  actions,
};
